/* ==========================================================================
   I Don't Give a Sock — productkaart: doorlopen van foto's bij hover
   Alleen op apparaten met een echte muisaanwijzer. Raakt de hero- en
   WOD-foto niet, want die staan buiten .card-wrapper.
   ========================================================================== */
(function () {
  var INTERVAL = 900;

  var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function imagesIn(media) {
    return Array.prototype.filter.call(media.children, function (el) {
      return el.tagName === 'IMG';
    });
  }

  function show(images, index) {
    images.forEach(function (img, i) {
      img.style.opacity = i === index ? '1' : '0';
    });
  }

  function reset(images) {
    images.forEach(function (img) {
      img.style.removeProperty('opacity');
    });
  }

  function bind(wrapper) {
    if (wrapper.dataset.igasGallery === 'on') return;

    var media = wrapper.querySelector('.media--hover-effect');
    if (!media) return;

    var images = imagesIn(media);
    if (images.length < 3) return; // Dawn regelt de tweede foto zelf al

    wrapper.dataset.igasGallery = 'on';

    var timer = null;
    var index = 1;

    function start() {
      if (!canHover.matches || reduceMotion.matches) return;
      index = 1;
      show(images, index);
      timer = setInterval(function () {
        index += 1;
        if (index >= images.length) index = 1;
        show(images, index);
      }, INTERVAL);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
      reset(images);
    }

    wrapper.addEventListener('mouseenter', start);
    wrapper.addEventListener('mouseleave', stop);
    wrapper.addEventListener('focusin', start);
    wrapper.addEventListener('focusout', stop);
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Nieuwe kaarten na filteren, pagineren of snel toevoegen
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-wrapper')) bind(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
